import { Directive, ElementRef, AfterViewInit, Renderer2, DOCUMENT, inject, input } from '@angular/core'

@Directive({
  selector: '[aoRequired]',
})
export class RequiredFieldDirective implements AfterViewInit {
  private el = inject<ElementRef<HTMLElement>>(ElementRef)
  private renderer = inject(Renderer2)
  private document = inject<Document>(DOCUMENT)

  readonly aoRequired = input<'' | boolean>()

  private requiredElement?: HTMLElement

  ngAfterViewInit() {
    this.init()
  }

  private init() {
    const element = this.el.nativeElement
    if (this.aoRequired() !== false && !this.requiredElement) {
      this.requiredElement = this.document.createElement('span')
      this.renderer.addClass(this.requiredElement, 'ao-required')
      this.renderer.setProperty(this.requiredElement, 'innerHTML', '*')
      this.renderer.appendChild(element, this.requiredElement)
    }
  }
}
